import { validateCompliance } from "utils";

export const objectionFields = [
  {
    label: '',
    id: 'objectionCommitteeComment',
    name: 'objectionCommitteeComment',
    type: 'textarea',
    rows: 10,
    maxLength: 1000,
    rules: [
      { required: true, message: <div>Το πεδίο είναι υποχρεωτικό</div> },
    ],
    asterisk: false,
  },
];